import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-tree-multi-select-dropdown',
  templateUrl: './tree-multi-select-dropdown.component.html',
  styleUrls: ['./tree-multi-select-dropdown.component.scss']
})
export class TreeMultiSelectDropdownComponent implements OnInit {

  @Input() placeHolder: string = '';
  @Input() formControlName: string = '';
  @Input() formGroup: FormGroup;
  @Input() treeData: any[] = [];

  @Output() onClickNodeEvent: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveEvent: EventEmitter<any> = new EventEmitter();

  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      id: node.id,
      name: node.name,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<any>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: any) => node.expandable;
  constructor() { }

  ngOnInit() {
    this.dataSource.data = [...this.treeData];
  }

  onClickNode(node: any): void {
    this.onClickNodeEvent.emit(node);
  }


  filterChanged(event: any) {
    this.filter(event?.target?.value);
    if (event) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }
  remove(value: string): void {
    this.onRemoveEvent.emit(value);
  }
  public filter(filterText: string) {
    let filteredTreeData;
    if (filterText) {
      // Filter the tree
      function filter(array, text) {
        const getChildren = (result, object) => {
          if (object.name.toLowerCase().includes(text.toLowerCase())) {
            result.push(object);
            return result;
          }
          if (Array.isArray(object.children)) {
            const children = object.children.reduce(getChildren, []);
            if (children.length) result.push({ ...object, children });
          }
          return result;
        };

        return array.reduce(getChildren, []);
      }

      filteredTreeData = filter(this.treeData, filterText);
    } else {
      // Return the initial tree
      filteredTreeData = this.treeData;
    }
    this.dataSource.data = filteredTreeData;
  }


}
